import { useContext, useEffect } from 'react';
import { TableContext } from './TableContext.es.js';
import { TABLE_EVENTS } from './Table.constants.es.js';

var useTableRowEventListener = function useTableRowEventListener(rowIndex, rowRef, isFocus, setIsFocus) {
  var _useContext = useContext(TableContext),
      focusedRowIndexRef = _useContext.focusedRowIndexRef,
      tableBodyNode = _useContext.tableBodyNode;

  useEffect(function () {
    var listener = function listener(e) {
      var _a, _b;

      var _e$detail = e.detail,
          newRowIndex = _e$detail.newRowIndex,
          didKeyboardNav = _e$detail.didKeyboardNav;

      if (rowIndex === newRowIndex) {
        setIsFocus(true);
        focusedRowIndexRef.current = rowIndex;

        if (didKeyboardNav) {
          ((_a = rowRef.current) == null ? void 0 : _a.scrollIntoView) && ((_b = rowRef.current) == null ? void 0 : _b.scrollIntoView({
            block: "center",
            inline: "nearest"
          }));
        }

        return;
      }

      if (isFocus) {
        setIsFocus(false);
      }
    };

    tableBodyNode == null ? void 0 : tableBodyNode.addEventListener(TABLE_EVENTS.ROW_CHANGED, listener);
    return function () {
      return tableBodyNode == null ? void 0 : tableBodyNode.removeEventListener(TABLE_EVENTS.ROW_CHANGED, listener);
    };
  }, [tableBodyNode, focusedRowIndexRef, isFocus, setIsFocus, rowIndex, rowRef]);
};

export { useTableRowEventListener };